// @ts-nocheck

import React, { useState, useRef, useCallback } from 'react';
import type { Node } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { __ } from '../../i18n/l10n';
import { SocialMediaButton } from '../../styled-components/shared';

type Props = {
  className?: string;
  text: string;
  children: Node;
};

const CopyButton = ({ className, children, text }: Props) => {
  const [copied, setCopied] = useState(false);
  const timeout = useRef(null);

  const onCopy = useCallback(() => {
    const start = async () => {
      clearTimeout(timeout.current);
      setCopied(true);
      timeout.current = setTimeout(() => {
        setCopied(false);
      }, 2000);
    };
    start();
    return () => {
      clearTimeout(timeout.current);
    };
  }, []);

  return (
    <CopyToClipboard text={text} onCopy={onCopy}>
      <SocialMediaButton className={className}>{!copied ? children : __('Copied')}</SocialMediaButton>
    </CopyToClipboard>
  );
};

export default CopyButton;
